
import { useState, useEffect } from "react";
import JobStreetView from "../../offers/status/jobStreetView";
import Send from '../../../../../_asset/img/send-2.svg';
import SideDrawer from "./sideDrawer";
import ProgressCircle from '../utils/ProgressCircle';

const UnassignedGridView = ({ data, getDeadlineText }) => {
    const [open, setOpen] = useState(false);
    const [getByItem, setGetByItem] = useState(null);
    const [selectedJob, setSelectedJob] = useState(null);

    useEffect(() => {
        if (!open) {
            setGetByItem(null);
        }
    }, [open]);

    return (
        <div className="font-inter grid grid-cols-3 gap-6">
            {data?.length > 0 &&
                data.map((job, index) => {
                    const deadlineText = getDeadlineText(job?.shifts) || "N/A";
                    const percent = job?.statistics?.overallCoverage || 0;
                    const color = percent === 100 ? '#52c41a' : '#3385ff';

                    return (
                        <div key={job?._id || index} className="bg-white rounded-lg overflow-hidden w-full box-border">
                            <div className="relative h-54">
                                <JobStreetView job={job} />
                                <span
                                    className="w-10 h-10 rounded-full bg-white shadow-lg flex items-center justify-center cursor-pointer absolute bottom-4 right-4 z-10"
                                    onClick={() => {
                                        setOpen(true);
                                        setSelectedJob(job);
                                    }}
                                >
                                    <img src={Send} alt="" />
                                </span>
                            </div>
                            <div className="p-5">
                                <div className="font-bold mb-2.5">
                                    <div className="text-xl font-medium mb-1 text-black">
                                        {job?.isLead 
                                            ? job?.contact?.name || "Unknown Contact"
                                            : job?.customer_company_id?.companyFriendlyName || "Unknown Company"
                                        }
                                    </div>
                                    <div className="text-sm font-normal text-gray-500">
                                        {job?.formattedAddress || "No Address"}
                                    </div>
                                </div>
                                <hr className="border-gray-200 my-4" />
                                <div className="grid grid-cols-3 gap-1 mb-4">
                                    <div>
                                        <p className="text-xs font-normal text-gray-500 mb-0.5">Fulfillment Deadline</p>
                                        <p className="text-base font-medium text-black m-0">{deadlineText}</p>
                                    </div>
                                    <div>
                                        <p className="text-xs font-normal text-gray-500 mb-0.5">Active Offers</p>
                                        <p className="text-base font-medium text-black m-0">{job?.statistics?.validOffersCount || 0}</p>
                                    </div>
                                    <div>
                                        <p className="text-xs font-normal text-gray-500 mb-0.5">Shift Coverage</p>
                                        <ProgressCircle
                                            percent={parseInt(percent.toFixed(0))}
                                            strokeColor={color}
                                            size={40}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}

            {/* Render the SideDrawer outside the map to prevent re-renders */}
            {selectedJob && open && (
                <SideDrawer
                    job={selectedJob}
                    isOpen={open}
                    setIsOpen={(state) => {
                        setOpen(state);
                        if (!state) setSelectedJob(null);
                    }}
                    getByItem={selectedJob}
                />
            )}
        </div>
    );
};

export default UnassignedGridView;
